import { Check, Pencil, Trash2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import type { FdeCopy } from '@/frontend/features/Fde/types'

export default function RecordActions({ proposed, copy, onEdit, onConfirm, onDelete }: {
  proposed: boolean; copy: FdeCopy; onEdit: () => void; onConfirm: () => void; onDelete: () => void
}) {
  return (
    <div className="flex shrink-0 items-center gap-1">
      {proposed && <Button size="icon-sm" variant="ghost" title={copy.workspace.confirm} aria-label={copy.workspace.confirm} onClick={onConfirm}><Check /></Button>}
      <Button size="icon-sm" variant="ghost" title={copy.common.edit} aria-label={copy.common.edit} onClick={onEdit}><Pencil /></Button>
      <Button size="icon-sm" variant="ghost" className="text-destructive hover:text-destructive" title={copy.common.delete} aria-label={copy.common.delete} onClick={onDelete}><Trash2 /></Button>
    </div>
  )
}
